import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux';
import { persistor, store } from "./store/index.ts"
import { PersistGate } from "redux-persist/integration/react";
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import ScrollToTop from './utility/ScrollToTop.ts';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
createRoot(document.getElementById('root')!).render(
  <Provider store={store}>

    <BrowserRouter basename={import.meta.env.VITE_PUBLIC_URL}>
      <PersistGate loading={null} persistor={persistor}>
        <ReactNotifications />
        <ScrollToTop />
        <App />
      </PersistGate>
    </BrowserRouter>
  </Provider>,
)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration.scope);
    })
    .catch((err) => console.error('Service Worker registration failed:', err));
}